import axios from '../config/axiosPrivate';

export const getCommunityShopNotes = async (communityId: number, params: any = {}) => {
  const response = await axios.get(`/communities/${communityId}/shop-notes`, { params });
  return response.data;
};
